import React, { useEffect } from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
        flexDirection: "row",
        backgroundColor: "white",
        paddingBottom: 20,
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 20,
    },
    section: {
        margin: 5,
        padding: 5,
        flexGrow: 1,
        borderStyle: "solid",
    },
    tableData: {
        display: "table",
        width: "100%",
        borderStyle: "solid",
        borderWidth: 0.5,
        marginBottom: 40,
    },
    tableRow: {
        flexDirection: "row",
    },
    tableCol: {
        width: "100%",
        borderStyle: "solid",
        borderWidth: 0.5,
    },
    tableColSrnumber: {
        width: "20%",
        borderStyle: "solid",
        borderWidth: 0.5,
    },
    tableColSrno: {
        width: "40%",
        borderStyle: "solid",
        borderWidth: 0.5,
    },
    tableCell: {
        margin: "auto",
        fontSize: 13,
        flexDirection: "col",
    },
    heading: {
        width: 200,
        fontWeight: "bold",
        marginTop: 10,
        marginBottom: 20,
        marginLeft: 320,
    },
    date: {
        width: 200,
        borderStyle: "solid",
        marginBottom: 45,
        fontSize: 15,
        marginLeft: "73%",
        fontWeight: "normal",
    },
    rangeDate: {
        width: 300,
        borderStyle: "solid",
        marginBottom: 55,
        fontSize: 15,
        fontWeight: "normal",
    },
});

function PrintSheet({ analytics }) {
    const currentDate = new Date();

    useEffect(() => { });

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap={true} orientation="landscape">
                <View style={styles.section}>
                    <Text style={styles.heading}>Medicine Sheet</Text>
                    <Text style={styles.date}>{currentDate.toLocaleString()}</Text>
                    <Text style={styles.rangeDate}>
                        Range: From: {analytics.formData.fromDate} - To: {analytics.formData.toDate}
                    </Text>
                    <View style={styles.tableData}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColSrnumber}>
                                <Text style={styles.tableCell}>Sr.no</Text>
                            </View>
                            <View style={styles.tableColSrno}>
                                <Text style={styles.tableCell}>Medicine Name</Text>
                            </View>
                            <View style={styles.tableColSrno}>
                                <Text style={styles.tableCell}>No of Patients</Text>
                            </View>
                        </View>
                        {analytics.data.map((result, index) => (
                            <View style={styles.tableRow} key={index}>
                                <View style={styles.tableColSrnumber}>
                                    <Text style={styles.tableCell}>{index + 1}</Text>
                                </View>
                                <View style={styles.tableColSrno}>
                                    <Text style={styles.tableCell}>{result.medicine_name}</Text>
                                </View>
                                <View style={styles.tableColSrno}>
                                    <Text style={styles.tableCell}>{result.no_of_patients}</Text>
                                </View>
                            </View>
                        ))}
                    </View>
                </View>
            </Page>
        </Document>
    );
}
export default PrintSheet;
